<!-- results-table.component.html -->
<h1 mat-dialog-title></h1>
<div mat-dialog-content fxLayout="column">

  <div fxLayout="column" fxFlex="100" class="print">

      <div fxLayout="row" class="p-20">

        <div fxFlex fxLayout="row">
            <div fxFlex="50"><strong>{{organizacion}}</strong></div>
            <div fxFlex="50" fxLayout="column">
                            <div fxFlex fxLayoutAlign="end start">
                <img class="logo-icon" src="assets/images/logos/logo_RIC_horizontal_transparente.png" height="67" width="200" >
              </div>
              <div fxFlex fxLayoutAlign="end start" style="margin-right:20px">
                {{fecha | date:'dd/MM/yyyy'}}
              </div>
          </div>
        </div>
      </div>

      <div>
        <h1 class="p-20"><strong>Indicador Clave de Riesgo (KRI)</strong></h1>
      </div>

      <div fxLayout="column" class="p-20">

        <div fxFlex fxLayout="row" class="p-10">
            <div fxFlex="70"><strong>Nombre: </strong>{{LOCAL_DATA.nombre}}</div>
            <div fxFlex="30"><strong>Dueño: </strong>{{LOCAL_DATA.owner.nombreCompleto}}</div>
        </div>
        <div fxFlex fxLayout="row" class="p-10">
            <div fxFlex="70"><strong>Tipo de Evaluación: </strong>{{LOCAL_DATA.tipo.nombre}}</div>
            <div fxFlex="30"><strong>Creado por: </strong>{{LOCAL_DATA.creador.nombreCompleto}}</div>
        </div>
        <div fxFlex fxLayout="row" class="p-10">
            <div fxFlex="70"><strong>Estructura jerarquíca/Nodo: </strong>{{LOCAL_DATA.estructuraJerarquica.nombre}} / {{LOCAL_DATA.nodoEstructuraJerarquica.nombre}}</div>
            <div fxFlex="30"><strong>Fecha inicio: </strong>{{LOCAL_DATA?.fechaInicio | date:'dd/MM/yyyy'}}</div>
        </div>
        <div fxFlex fxLayout="row" class="p-10">
            <div fxFlex="70"><strong>Escenario: </strong>{{LOCAL_DATA.escenario.nombre}}</div>
            <div fxFlex="30"><strong>Fecha fin: </strong>{{LOCAL_DATA?.fechaFin | date:'dd/MM/yyyy'}}</div>
        </div>
        <div fxFlex fxLayout="row" class="p-10">
            <div fxFlex="70"><strong>Estado: </strong>{{LOCAL_DATA.estado}}</div>
        </div>
        <div fxFlex fxLayout="row" class="p-10">
            <div fxFlex="70"><strong>Analistas: </strong>
              <span *ngFor="let usuario of LOCAL_DATA.usuarios; let isLast=last">{{usuario.nombreCompleto}} {{isLast ? '' : ', '}}</span>
            </div>
        </div>
      </div>
  </div>

  <div class="content" fxFlex="100" fxLayout="row">

      <div fxFlex class="content p-20">
        <table mat-table [dataSource]="dataSource" #tableProbabilidad class="my-table mat-elevation-z8 select-list" fxFlex>

          <ng-container matColumnDef="kri">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>KRI</th>
            <td mat-cell *matCellDef="let element">
                {{element.kri.nombre}}
            </td>
          </ng-container>

          <ng-container matColumnDef="nodo">
            <th mat-header-cell *matHeaderCellDef> Nodo </th>
            <td mat-cell *matCellDef="let element">
                  {{element.kri.nodo?.nombre}} / {{element.kri.estructura?.nombre}}
            </td>
          </ng-container>

          <ng-container matColumnDef="frecuencia">
            <th mat-header-cell *matHeaderCellDef> Frecuencia </th>
            <td mat-cell *matCellDef="let element">
                  {{element.kri.frecuencia}}
            </td>
          </ng-container>

          <!--
          <ng-container matColumnDef="referente">
            <th mat-header-cell *matHeaderCellDef> Referente </th>
            <td mat-cell *matCellDef="let element">
              {{element.kri.referente}}
            </td>
          </ng-container>-->

          <ng-container matColumnDef="responsable">
            <th mat-header-cell *matHeaderCellDef> Responsable </th>
            <td mat-cell *matCellDef="let element">
              {{element.kri.responsable?.nombreCompleto}}
            </td>
          </ng-container>

          <ng-container matColumnDef="riesgos">
            <th mat-header-cell *matHeaderCellDef> Riesgos </th>
            <td mat-cell *matCellDef="let element">
              <div fxLayout="column">
                <span *ngFor="let riesgo of element.riesgos; let isLast=last">{{riesgo.riesgo?.nombre}}</span>
              </div>
            </td>
          </ng-container>

            <ng-container matColumnDef="exposicionResidual">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Exposición Residual </th>
              <td mat-cell *matCellDef="let element">
                <div fxLayout="column">
                  <span *ngFor="let riesgo of element.riesgos; let isLast=last">{{riesgo.topAnalisisResidual?.exposicion | number:'1.2-2'}}</span>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="clasificacion">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Clasificación</th>
              <td mat-cell *matCellDef="let element" >
                <div fxLayout="column">
                  <div *ngFor="let riesgo of element.riesgos; let isLast=last" [ngClass]="{'success' : riesgo.topAnalisisResidual.clasificacion=='Aceptable',  'error' : riesgo.topAnalisisResidual.clasificacion=='Inaceptable', 'warning' : riesgo.topAnalisisResidual.clasificacion=='Atención'}">{{riesgo.topAnalisisResidual.clasificacion}} </div>
                </div>
              </td>
            </ng-container>


          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="print"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="print"></tr>
        </table>
      </div>

  </div>

<div mat-dialog-actions>
  <button mat-button (click)="printPdf()">{{'Imprimir' | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
